export const logo = '/assets/logo.png'
export const logoCroppedCircle = '/assets/logo_cropped_circle.png'
export const letsGo = '/assets/letsgo.png'
export const chromeLogo = '/assets/ChromeLogo.png'
export const robot = '/assets/robot.png'
export const fullLogoWhite = '/assets/logo_full_white.png'
export const fullLogo = '/assets/logo_full.png'
export const christmasHat = '/assets/christmas_hat.png'
export const googleDriveLogo = '/assets/google-drive.png'
export const dropboxLogo = '/assets/dropbox.png'
export const oneDriveLogo = '/assets/onedrive.png'
export const sharepointLogo = '/assets/sharepoint.png'
export const egnyteLogo = '/assets/egnyte.png'
export const pdfLogo = '/assets/icon_pdf.png'
export const edgeLogo = '/assets/icon_edge.png'
export const powerpointLogo = '/assets/icon_powerpoint.png'
export const wordLogo = '/assets/icon_word.png'
export const youtubeLogo = '/assets/icon_youtube.png'
export const teamsLogo = '/assets/icon_teams.png'
export const OnboardingBrain = '/assets/OnboardingBrain_Illustration.png'
export const OnboardingApps = '/assets/OnboardingApps_Illustration.png'
export const OnboardingExtension = '/assets/OnboardingExtension_Illustration.png'
export const OnboardingChat = '/assets/OnboardingChat_Illustration.png'
export const newWordLogo = '/assets/logo_word_2.png'
export const excelLogo = '/assets/logo_excel.png'
export * from './icons'
export * from './app_icons'
